import React, { useEffect } from "react";
import { Card, Col, Row } from "antd";
import styled from "styled-components";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

import Hotelservices from "../image/Hotelservices.jpg";
import Imexpservices from "../image/Im-expservices.jpg";
import Realservices from "../image/Realservices.png";
import textileservices from "../image/textileservices.jpg";

const { Meta } = Card;

const Container = styled.div`
  margin-top: 90px;
  padding: 0 50px; /* Left and right spacing */
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
`;

const StyledCard = styled(Card)`
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  position: relative;

  &:hover {
    transform: scale(1.06);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
  }

  &:hover .overlay {
    opacity: 1;
  }

  .ant-card-cover img {
    border-radius: 12px 12px 0 0;
    height: 240px;
    object-fit: cover;
    width: 100%;
    display: block;
  }
`;

const MotionWrapper = styled(motion.div)`
  width: 100%;
  overflow: hidden;
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  transition: opacity 0.4s ease;
  text-align: center;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
`;

const galleryData = [
  { id: 1, title: "Hotel Services", img: Hotelservices },
  { id: 2, title: "Import & Export", img: Imexpservices },
  { id: 3, title: "Luxury Hotels", img: Hotelservices },
  { id: 4, title: "Real Estate", img: Realservices },
  { id: 5, title: "Textile Industry", img: textileservices },
  { id: 6, title: "Global Hotels", img: Hotelservices },
];

const Galleryoptics = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <Container>
      <Row
        gutter={[24, 24]}
        justify="center"
        style={{
          margin: "50px -47px 30px",  // Left & right negative margin
          rowGap: "24px",             // Row spacing
        }}
      >
        {galleryData.map((item) => (
          <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
            <MotionWrapper whileHover={{ scale: 1.03 }} data-aos="fade-up">
              <StyledCard hoverable cover={<img alt={item.title} src={item.img} />}>
                <Overlay className="overlay">{item.title}</Overlay>
                <Meta title={item.title} />
              </StyledCard>
            </MotionWrapper>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Galleryoptics;
